import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

let router = new Router({
  scrollBehavior() {
    return window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  mode: "history",
  routes: [
    {
      path: '/',
      meta: { layout: 'userpages' },
      component: () => import('../views/RootLanding.vue'),
    },
    {
      path: '/get',
      meta: { layout: 'userpages' },
      component: () => import('../views/GetApp.vue'),
    },
    {
      path: '/remove',
      meta: { layout: 'userpages' },
      component: () => import('../views/RemoveData.vue'),
    },
    {
      path: '/privacy',
      meta: { layout: 'userpages' },
      component: () => import('../views/Privacy.vue'),
    },
    {
      path: '/support',
      meta: { layout: 'userpages' },
      component: () => import('../views/Support.vue'),
    },
  ]
})

router.beforeEach((to, from, next) => {
  next();
});

export default router
